import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
// import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
// import { jsPDF } from "jspdf";
import { RxReload } from "react-icons/rx";
// import "jspdf-autotable";
import { toast } from "react-toastify";
import {
  MdDelete,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
  MdUndo,
  MdDeleteForever,
  MdPreview,
  MdGroups,
  MdCheckCircle,
  MdPending,
  MdTrendingUp,
  MdRefresh,
  MdRestore,
  MdRecycling
} from "react-icons/md";
import { FiRefreshCw, FiUpload, FiTrash2 } from "react-icons/fi";
import { BiRecycle } from "react-icons/bi";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.css";

import edititem from "../../../components/Images/edititem.svg";
import deleteitem from "../../../components/Images/deleteitem.svg";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";

// Enhanced CSS with animations and better styling
const enhancedStyles = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideIn {
    from { opacity: 0; transform: translateX(-20px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
  .spin {
    animation: spin 1s linear infinite;
  }
  .fade-in {
    animation: fadeIn 0.5s ease-out;
  }
  .slide-in {
    animation: slideIn 0.3s ease-out;
  }
  .pulse {
    animation: pulse 2s infinite;
  }
    .undo-panel {
    background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
    border-radius: 10px;
    border-left: 4px solid #2d3436;
    box-shadow: 0 4px 15px rgba(116, 185, 255, 0.3);
    animation: slideIn 0.5s ease-out;
    color: white;
  }
  .undo-panel .btn {
    border: 1px solid white;
    margin-left: 8px;
  }
  .undo-panel .btn-primary {
    background: #00b894;
    border-color: #00b894;
  }
  .undo-panel .btn-secondary {
    background: #636e72;
    border-color: #636e72;
  }
  .recycle-badge {
    background: #e17055;
    color: white;
    border-radius: 50px;
    padding: 4px 12px;
    font-size: 12px;
    animation: pulse 2s infinite;
    font-weight: bold;
  }
  .commission-high {
    color: #27ae60 !important;
    font-weight: bold;
    font-size: 14px;
  }
  .commission-medium {
    color: #f39c12 !important;
    font-weight: bold;
    font-size: 14px;
  }
  .commission-low {
    color: #95a5a6 !important;
    font-size: 14px;
  }
  .partner-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 16px;
    margin-right: 12px;
  }
  .status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .status-approved {
    background: #27ae60;
    color: white;
  }
  .status-pending {
    background: #f39c12;
    color: white;
  }
  .status-rejected {
    background: #e74c3c;
    color: white;
  }
  .action-button {
    transition: all 0.2s ease;
  }
  .action-button:hover {
    transform: translateY(-1px);
  }
  .recycle-bin-header {
    background: linear-gradient(135deg, #ff7675 0%, #fd79a8 100%);
    color: white;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .countdown-timer {
    font-weight: bold;
    color: white;
    margin-left: 10px;
  }
  .control-buttons {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  .btn-undo {
    background: #3498db;
    border-color: #3498db;
    color: white;
    margin-right: 10px;
  }
  .btn-permanent-delete {
    background: #e74c3c;
    border-color: #e74c3c;
    color: white;
    margin-right: 10px;
  }
`;

// Add styles to document head
if (!document.querySelector('#enhanced-partner-styles')) {
  const style = document.createElement('style');
  style.id = 'enhanced-partner-styles';
  style.textContent = enhancedStyles;
  document.head.appendChild(style);
}

function PartnerIndex(props) {
  const [allPartner, setAllPartner] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [filter, setFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [draft, setDraft] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showRecycleBin, setShowRecycleBin] = useState(false);
  const [recycleBinData, setRecycleBinData] = useState([]);
  const [refreshing, setRefreshing] = useState(false);

  // Statistics state
  const [statistics, setStatistics] = useState({
    total: 0,
    active: 0,
    pending: 0,
    avgCommission: 0
  });

  // Undo functionality
  const [recentlyDeleted, setRecentlyDeleted] = useState([]);
  const [showUndoPanel, setShowUndoPanel] = useState(false);
  const [undoCountdown, setUndoCountdown] = useState(10);
  const undoTimerRef = useRef(null);


  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json", Authorization: "Bearer " + access_token,
    Accept: "application/json", "Access-Control-Allow-Origin": "*"
  };

  // Calculate statistics from partner data
  const calculateStatistics = useCallback((partners) => {
    const stats = {
      total: partners.length,
      active: partners.filter(p => p.status === "Approved").length,
      pending: partners.filter(p => p.status === "Pending").length,
      avgCommission: 0
    };

    // Calculate average commission
    const commissions = partners
      .map(p => parseFloat(p.commission_percentage || p.commission || 0))
      .filter(c => !isNaN(c) && c > 0);

    if (commissions.length > 0) {
      stats.avgCommission = commissions.reduce((a, b) => a + b, 0) / commissions.length;
    }

    setStatistics(stats);
  }, []);

  // Enhanced Excel generation
  const generateXLSX = async (dataType = 0) => {
    const XLSX = await import("xlsx");
    const data = dataType === 1 ? allPartner : filteredData;
    const exportData = data.map(item => ({
      ID: item.id,
      'Partner Name': item.username || 'N/A',
      Email: item.email || 'N/A',
      'Mobile Number': item.mobile_number || 'N/A',
      'Commission %': (item.commission_percentage || 0) + '%',
      Status: item.status || 'N/A',
      'Created Date': item.created_at || 'N/A'
    }));

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, "Partners");
    XLSX.writeFile(wb, `PARTNER-LIST-${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success("Excel file downloaded successfully!");
  };
  const openModal = () => {
    setModelClose(true);
  };
  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };
  const closeModal = () => {
    setModelClose(!closeModal);
  };
  const handleDeletedata = () => {
    if (showRecycleBin) {
      handleMultiplePermanentDelete();
    } else {
      handleDelete();
    }
    closeModal();
  };
  const conditionalGeneratePDF = async (get) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    doc.text(" PARTNER LIST", 10, 10);

    const columns = ["Index", "ID", "EMAIL ID", "MOBILE NUMBER", "STATUS"];
    const allDataPDF = allPartner.map((item, index) => [
      index + 1,
      item?.id,
      item?.email,
      item?.mobile_number,
      item?.status,
    ]);
    const filterPDF = filteredData.map((item, index) => [
      index + 1,
      item?.id,
      item?.email,
      item?.mobile_number,
      item?.status,
    ]);
    doc.autoTable({
      startY: 20,
      head: [columns],
      body: get == 1 ? allDataPDF : filterPDF,
    });
    doc.save("PARTNER-LIST.pdf");
  };
  const statusFormatter = (data, row) => {
    return (
      <div
        className={`font-weight-bolder d-flex justify-content-center  ${data === "Pending"
          ? "DISABLED_active" : data === "Approved" ? "PUBLISHED_active" : "UNPUBLISHED_active"}`} >
        {data}
      </div>
    );
  };
  const fetchPartners = async () => {
    try {
      console.log("Fetching partners data...");
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/partner/index`,
        { headers: headers }
      );

      console.log("API Response:", response.data);

      // Handle different possible response structures
      let result = response?.data?.data || response?.data?.partners || response?.data || [];

      // If result is not an array, check if it's an object with array property
      if (!Array.isArray(result)) {
        console.warn("Result is not an array:", result);
        // Try to find array data in different possible locations
        if (result && typeof result === 'object') {
          const possibleArrays = Object.values(result).filter(Array.isArray);
          if (possibleArrays.length > 0) {
            result = possibleArrays[0];
            console.log("Found array data:", result);
          } else {
            result = [];
          }
        } else {
          result = [];
        }
      }

      console.log("Processing partners data:", result);

      if (Array.isArray(result) && result.length > 0) {
        const updatedPartnerList = result.map((item) => {
          const statusText =
            item?.status === 0 || item?.status === null
              ? "Pending" : item?.status === 1 ? "Approved" : "Rejected";
          return {
            ...item,
            status: statusText,
            // created_at: item?.created_at ? formatDate(item?.created_at) : 'N/A',
            // Ensure required fields have fallback values
            username: item?.user_name,
            email: item?.email,
            mobile_number: item?.mobile_number,
            commission_percentage: item?.commission_percentage,
          };
        });

        console.log("Updated partner list:", updatedPartnerList);
        setAllPartner(updatedPartnerList);
        setFilteredData(updatedPartnerList);
        calculateStatistics(updatedPartnerList);
      } else {
        console.warn("No partner data found or result is empty");
        setAllPartner([]);
        setFilteredData([]);
        setStatistics({ total: 0, active: 0, pending: 0, avgCommission: 0 });
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching partners data:", error);
      console.error("Error response:", error.response);
      toast.error("Failed to load partners data. Please try again.");
      setAllPartner([]);
      setFilteredData([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    const initializeData = async () => {
      await fetchPartners();
    };
    initializeData();
  }, []);
  const actionFormatter = (data, row) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <span>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </span>
        </span>
        <div className="editdropdown-menu">
          <Link
            to={`/partner-edit/${row.id}`}
            id={`partner-edit-${row.id}`}
            className="commonActionPadding"
            title="Edit Partner"
          >
            <span>
              <img src={edititem} alt="flogo" width={20} height={20} />
              <span className="ms-2">Edit</span>
            </span>
          </Link>

          {/* <div
            onClick={() => handlePreview(row)}
            className="commonActionPadding"
            title="Preview Partner"
          >
            <MdPreview size={20} />
            <span className="ms-2">Preview</span>
          </div> */}

          {!showRecycleBin ? (
            <div
              onClick={() => singleDelete(row.id)}
              id={`partner-delete-${row.id}`}
              className="commonActionPadding"
              title="Move to Recycle Bin"
            >
              <img src={deleteitem} alt="flogo" width={20} height={20} />
              <span className="ms-2">Delete</span>
            </div>
          ) : (
            <>
              <div
                onClick={() => handleUndoDelete(row.id)}
                className="commonActionPadding"
                title="Restore from Recycle Bin"
              >
                <MdUndo size={20} />
                <span className="ms-2">Undo</span>
              </div>
              <div
                onClick={() => handlePermanentDelete(row.id)}
                className="commonActionPadding"
                title="Permanently Delete Partner"
              >
                <MdDeleteForever size={20} />
                <span className="ms-2">Delete Permanent</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  function formatDate(isoDate) {
    const date = new Date(isoDate);
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
    return `${formattedDate} ${formattedTime}`;
  }
  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData.map((item) => item?.id));
  };
  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete.filter((id) => id !== row?.id));
        }
      }
    },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked, indeterminate }) => (
      <div>
        <input type="checkbox" checked={checked} indeterminate={indeterminate} onChange={handleAll} />
      </div>
    ),
  };
  const exportHeaders = [
    { label: "Id", key: "id" },
    { label: "Partner Name", key: "partner_name" },
    { label: "Email", key: "email" },
    { label: "Mobile Number", key: "mobile_number" },
    { label: "Status", key: "status" },
  ];
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredData.length },
    ],
  });
  const handleFilterChange = (event) => {
    const searchTerm = event.target.value;
    setFilter(searchTerm);
    const searchTermLower = searchTerm.toLowerCase();
    const dataToFilter = showRecycleBin ? recycleBinData : allPartner;
    const filteredResults = dataToFilter.filter((item) => {
      return (
        (typeof item?.created_at === "string" &&
          item?.created_at.toLowerCase().includes(searchTermLower)) ||
        (typeof item?.channel_name === "string" &&
          item?.channel_name.toLowerCase().includes(searchTermLower)) ||
        (typeof item?.email === "string" &&
          item?.email.toLowerCase().includes(searchTermLower)) ||
        (typeof item?.status === "string" &&
          item?.status.toLowerCase().includes(searchTermLower)) ||
        (typeof item?.id === "number" &&
          item?.id.toString().toLowerCase().includes(searchTermLower)) ||
        (typeof item?.mobile_number == "string" &&
          item?.mobile_number.toLowerCase().includes(searchTermLower))
      );
    });
    setFilteredData(filteredResults);
  };

  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: false,
      headerClasses: "idClass",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      dataField: "username",
      text: "Partner Name",
      sort: true,
      formatter: (cell, row) => {
        // Handle different possible name fields
        return cell || row?.user_name;
      },
    },
    {
      dataField: "email",
      text: "Email Id",
      sort: true,
      formatter: (cell, row) => {
        return cell || row?.user_email;
      },
    },
    {
      dataField: "mobile_number",
      text: "Mobile Number",
      sort: true,
      formatter: (cell, row) => {
        return cell || row?.user_mobile;
      },
    },
    {
      dataField: "commission_percentage",
      text: "Commission %",
      sort: true,
      formatter: (cell, row) => {
        const commission = parseFloat(cell || 0);
        let className = "commission-low";

        if (commission >= 15) {
          className = "commission-high";
        } else if (commission >= 10) {
          className = "commission-medium";
        }

        return (
          <span className={className}>
            {commission.toFixed(1)}%
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusFormatter,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: actionFormatter,
    },
  ];
  const handleClear = () => {
    fetchPartners();
    setFilter("");
  };

  // const handleDelete3 = async () => {
  //   setProcessing(true);
  //   setShowOverlay(true);
  //   const formData = new FormData();
  //   formData.append("partner_ids", "[" + itemToDelete + "]");
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_Baseurl}/admin/partner/multi-delete`,
  //       formData,
  //       { headers: headers }
  //     );
  //     const result = response.data;
  //     console.log(result, 'result');

  //     if (result.status === true) {
  //       fetchPartners();
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 2000);
  //       // props?.setApiresponsealert(result);
  //       props?.setShowalert(true);
  //       setProcessing(false);
  //       setShowOverlay(false);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     var errorMessage = err.response.data.message;
  //     props?.setApiresponsealert({ status: false, message: errorMessage });
  //     props?.setShowalert(true);
  //     setProcessing(false);
  //     setShowOverlay(false);
  //   }
  // };
  // Refresh functionality - ALWAYS SHOW NORMAL PARTNER DATA
  const handleRefresh = async () => {
    setRefreshing(true);
    setShowRecycleBin(false); // Always go back to normal view on refresh
    // Clear selected items when refreshing
    setItemToDelete([]);
    setSelectAll(false);
    try {
      await fetchPartners();
      toast.success("Partner data refreshed!");
    } catch (error) {
      console.error("Error refreshing:", error);
      toast.error("Failed to refresh data");
    } finally {
      setRefreshing(false);
    }
  };

  // Fetch recycle bin data
  const fetchRecycleBin = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/partner/recylePartners`, { headers: headers }
      );
      const result = response?.data?.data || [];
      console.log("Recycle bin result:", result);

      if (Array.isArray(result)) {
        const updatedRecycleBinList = result.map((item) => {
          const statusText =
            item?.status === 0 || item?.status === null
              ? "Pending" : item?.status === 1 ? "Approved" : "Rejected";
          return {
            ...item,
            status: statusText,
            // created_at: item?.created_at ? formatDate(item?.created_at) : 'N/A',
            username: item?.user_name,
            email: item?.email,
            mobile_number: item?.mobile_number,
            commission_percentage: item?.commission_percentage,
          };
        });

        setRecycleBinData(updatedRecycleBinList);
        setFilteredData(updatedRecycleBinList);
      } else {
        setRecycleBinData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching recycle bin data:", error);
      setRecycleBinData([]);
      setFilteredData([]);
    }
  };

  // Show recycle bin data (not a toggle - always shows recycle bin when clicked)
  const showRecycleBinData = async () => {
    setShowRecycleBin(true);
    setLoading(true);
    // Clear selected items when switching to recycle bin view
    setItemToDelete([]);
    setSelectAll(false);
    await fetchRecycleBin();
    setLoading(false);
  };

  // Soft delete (move to recycle bin)
  const handleDelete = async () => {
    setProcessing(true);
    setShowOverlay(true);

    const payload = {
      partner_ids: itemToDelete,
      action: 0
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/multi-delete`, payload, { headers: headers }
      );
      const result = response?.data;
      if (result?.status === true) {
        fetchPartners();
        toast?.success(result?.message || "Items moved to recycle bin");
        setItemToDelete([]);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console?.error(err);
      var errorMessage = err.response?.data?.message || "An error occurred.";
      toast?.error(errorMessage);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  // Permanent delete
  const handlePermanentDelete = async (id) => {
    setProcessing(true);
    setShowOverlay(true);

    const payload = {
      partner_ids: [id],
      action: 1
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/multi-delete`, payload, { headers: headers }
      );
      const result = response?.data;
      if (result?.status === true) {
        if (showRecycleBin) {
          fetchRecycleBin();
        } else {
          fetchPartners();
        }
        toast?.success(result?.message || "Item permanently deleted");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console?.error(err);
      var errorMessage = err.response?.data?.message || "An error occurred.";
      toast?.error(errorMessage);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  // Undo delete (restore from recycle bin)
  const handleUndoDelete = async (id) => {
    setProcessing(true);
    setShowOverlay(true);

    const payload = {
      partnerIds: [id], // Changed from partnerIds to partner_ids to match API
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/restore`, payload, { headers: headers }
      );
      const result = response?.data;
      if (result?.status === true) {
        await fetchRecycleBin(); // Refresh recycle bin view
        await fetchPartners(); // Refresh main partners list
        toast?.success(result?.message || "Item restored successfully");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console?.error(err);
      var errorMessage = err.response?.data?.message || "An error occurred.";
      toast?.error(errorMessage);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  // Multiple restore (undo) for selected items
  const handleMultipleUndo = async () => {
    setProcessing(true);
    setShowOverlay(true);

    const payload = {
      partnerIds: itemToDelete,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/restore`, payload, { headers: headers }
      );
      const result = response?.data;
      if (result?.status === true) {
        await fetchRecycleBin(); // Refresh recycle bin view
        await fetchPartners(); // Refresh main partners list
        toast?.success(result?.message || "Items restored successfully");
        setItemToDelete([]);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console?.error(err);
      var errorMessage = err.response?.data?.message || "An error occurred.";
      toast?.error(errorMessage);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  // Multiple permanent delete for selected items
  const handleMultiplePermanentDelete = async () => {
    setProcessing(true);
    setShowOverlay(true);

    const payload = {
      partner_ids: itemToDelete,
      action: 1 // Permanent delete
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/partner/multi-delete`, payload, { headers: headers }
      );
      const result = response?.data;
      if (result?.status === true) {
        await fetchRecycleBin(); // Refresh recycle bin view
        toast?.success(result?.message || "Items permanently deleted");
        setItemToDelete([]);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (err) {
      console?.error(err);
      var errorMessage = err.response?.data?.message || "An error occurred.";
      toast?.error(errorMessage);
      setProcessing(false);
      setShowOverlay(false);
    }
  };

  // Preview functionality
  const handlePreview = (row) => {
    // You can implement preview modal or navigate to preview page
    console.log("Preview partner:", row);
    toast.info(`Previewing ${row.username || row.email}`);
  };


  return (
    <>
      <div className={`modal packageModel ${modelClose ? "show fade" : ""}`} tabindex="-1" style={{ display: `${modelClose ? "block" : "none"}` }} >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Confirm</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
            </div>
            <div className="modal-body">
              {itemToDelete.length === 1 ? (<p> Are you sure you want to delete this item ?</p>) :
                (<p className="fs-6">Are you sure you want to delete the selected items ? </p>)}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModal}>
                Close
              </button>
              <button type="button" className="btn btn-danger" onClick={handleDeletedata} > Yes </button>
            </div>
          </div>
        </div>
      </div>
      <div> {showOverlay && <Response_Processing></Response_Processing>}</div>
      <div className=" m-0 p-0">
        <div className="">
          <section className="section container-fluid pt-3">
            <div id="content-page" className="content-page">
              {/* Statistics Cards - Enhanced UI */}
              {/* {!showRecycleBin && ( */}
              <div className="row mb-4 fade-in">
                <div className="col-xl-3 col-md-6 mb-3">
                  <div className="card  total  h-100">
                    <div className="card-body d-flex align-items-center">
                      <div className="mr-3">
                        <MdGroups size={40} className="" />
                      </div>
                      <div className="flex-grow-1 ml-3 ms-2">
                        <h6 className="">Total Partners</h6>
                        <div className="h5 mb-0 ">{statistics.total}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 mb-3">
                  <div className="card active  h-100">
                    <div className="card-body d-flex align-items-center">
                      <div className="mr-3">
                        <MdCheckCircle size={40} className="" />
                      </div>
                      <div className="flex-grow-1 ml-3">
                        <h6 className="">Active Partners</h6>
                        <div className="h5 mb-0 ">{statistics.active}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 mb-3">
                  <div className="card  pending  h-100">
                    <div className="card-body d-flex align-items-center">
                      <div className="mr-3">
                        <MdPending size={40} className="" />
                      </div>
                      <div className="flex-grow-1 ml-3">
                        <h6 className="">Pending Partners</h6>
                        <div className="h5 mb-0 ">{statistics.pending}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 mb-3">
                  <div className="card  h-100">
                    <div className="card-body d-flex align-items-center">
                      <div className="mr-3">
                        <MdTrendingUp size={40} className="" />
                      </div>
                      <div className="flex-grow-1 ml-3">
                        <h6 className="">Avg Commission</h6>
                        <div className="h5 mb-0 ">{statistics.avgCommission.toFixed(1)}%</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* )} */}

              {/* Recycle Bin Header */}
              {/* {showRecycleBin && (
                <div className="recycle-bin-header text-center slide-in">
                  <div className="d-flex align-items-center justify-content-center">
                    <MdRecycling size={30} className="mr-3" />
                    <div>
                      <h6 className="mb-0">Recycle Bin</h6>
                      <small>Deleted partners can be restored or permanently deleted</small>
                    </div>
                  </div>
                  <div className="mt-2">
                    <span className="recycle-badge">{recycleBinData?.length} items in recycle bin</span>
                  </div>
                </div>
              )} */}

              <div className="iq-card-header d-flex justify-content-between pb-3 flex-wrap">
                <div className="col-md-6 col-12">
                  <h6 className="">
                    {showRecycleBin ? 'Recycle Bin' : 'Partner Lists'}
                    <span className="fs-6"> ({showRecycleBin ? recycleBinData?.length : allPartner?.length} results found)
                    </span>
                  </h6>
                </div>
                <div className="col-md-6 col-12 mt-3 mt-md-0" align="right">
                  {itemToDelete.length > 0 && (
                    <>
                      {showRecycleBin ? (
                        // Recycle bin view - show both Undo and Delete Permanent buttons
                        <>
                          <button
                            className="btn btn-info d-inline-flex fw-bolder me-3"
                            onClick={() => handleMultipleUndo()}
                            title="Restore selected items"
                          >
                            <MdUndo className="exportIcon" /> Undo
                          </button>
                          <button
                            className="btn btn-danger d-inline-flex fw-bolder me-3"
                            onClick={openModal}
                            title="Permanently delete selected items"
                          >
                            <MdDeleteForever className="exportIcon" /> Delete Permanent
                          </button>
                        </>
                      ) : (
                        // Normal view - show regular Delete button
                        <button className="btn btn-danger d-inline-flex fw-bolder me-3" onClick={openModal}>
                          <MdDelete className="exportIcon" /> Delete
                        </button>
                      )}
                    </>
                  )}

                  {!showRecycleBin && (
                    <Link to="/partner-create" className="btn btn-primary fw-bolder">
                      <i className="fa fa-plus-circle"></i> Add Partner
                    </Link>
                  )}
                </div>
              </div>
              <div className="iq-card">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="">
                      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                        <div className="filterContainer">
                          <input type="text" placeholder="Filter all.." className="filter form-control"
                            value={filter} onChange={handleFilterChange} />
                          {filter?.length > 0 && (
                            <button type="button" className="closeBtn" onClick={handleClear}>
                              <i className="fa fa-times"></i>
                            </button>
                          )}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <button id="recycleButton" className={`reloadButton custom-tool-tip-parent p-2 me-2  border border-2 rounded-circle theme-border-color ${showRecycleBin ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`}
                            onClick={showRecycleBinData}
                            title="Show Recycle Bin"
                          >
                            <BiRecycle style={{ width: "18px", height: "15px" }} />
                          </button>

                          <button id="reloadButton" className={`bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `}
                            onClick={handleRefresh}
                            disabled={refreshing}
                            title="Refresh"
                          >

                            <RxReload style={{ width: "18px", height: "15px" }} className={`exportIcon ${refreshing ? 'spin' : ''}`} />
                          </button>
                        </div>


                        <div className="btn-group gap-3">
                          <div className="dropdown d-block" key={"2"}>
                            <button className="btn btn-success dropdown-toggle d-flex" type="button"
                              id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                              <span className="fw-bolder">Export </span>
                              <img src={ExportIcon} className="ms-2 exportIcon" />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                              <li className="dropdown-item">
                                <CSVLink headers={exportHeaders} data={filteredData} className="text-dark d-block"
                                  filename="PARTNER-LIST.csv"> CSV </CSVLink>
                              </li>
                              <li className="dropdown-item" onClick={() => { conditionalGeneratePDF(0); }}> PDF</li>
                              <li className="dropdown-item" onClick={() => { generateXLSX(0); }}>XLSX</li>
                            </ul>
                          </div>
                          <div className="dropdown d-block">
                            <button className="btn btn-success dropdown-toggle d-flex"
                              type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" >
                              <span className="fw-bolder">Export All</span>
                              <img src={ExportIcon} className="ms-2 exportIcon" />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                              <li className="dropdown-item">
                                <CSVLink headers={exportHeaders}
                                  data={allPartner} className="text-darkd d-block" filename="PARTNER-LIST.csv">CSV
                                </CSVLink>
                              </li>
                              <li className="dropdown-item" onClick={() => { conditionalGeneratePDF(1); }}> PDF </li>
                              <li className="dropdown-item" onClick={() => { generateXLSX(1); }} > XLSX</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="bootstrapTable overflow-auto">
                        <BootstrapTable
                          keyField="id"
                          columns={columns}
                          data={filteredData}
                          pagination={pagination}
                          noDataIndication={
                            <div className="noRecord text-center py-4">
                              {loading ? (
                                <div>
                                  <Response_Loading_processing></Response_Loading_processing>
                                  {/* <p className="mt-2">Loading partners data...</p> */}
                                </div>
                              ) : (
                                <div>
                                  <p className="mb-2">No partners found!</p>
                                  {/* <small className="text-muted">
                                    {showRecycleBin ? "Recycle bin is empty" : "Try refreshing or check your filters"}
                                  </small> */}
                                </div>
                              )}
                            </div>
                          }
                          hover
                          className="no-border-table table-responsive-md"
                          selectRow={selectRow}
                          selectAll={selectAll} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
export default PartnerIndex;